import Vue from 'vue'
import Router from 'vue-router'
import App from './../App'
import Legal from './../components/Legal'
import AppUber from './../AppUber'

Vue.use(Router)

const routes = [
  {path: '/uber', component: AppUber},
  {path: '/legal', component: Legal},
  {path: '/', component: App}
]

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js